import React from 'react'
import translatePath from './translatePath'

export const defaultX = 0
export const defaultY = 0
export const width = 550
export const height = 1150

export const path = [
  'M275,0 C425.359523,0 547.53469,120.671572 549.963158,270.452372 L550,275 L550,875 C550,1026.87831 426.878306,1150 275,1150 C225.537052,1150 179.124149,1136.94121 139.020889,1114.08322 C125.850246,1135.6224 102.104157,1150 75,1150 C33.9928573,1150 0.672357147,1117.08957 0.0100478572,1076.24026 L0,1075 L0,275 C0,123.121694 123.121694,0 275,0 Z',
  'M275,150 C206.654762,150 151.120595,204.850715 150.016746,272.932896 L150,275 L150,875 C150,944.035594 205.964406,1000 275,1000 C343.345238,1000 398.879405,945.149285 399.983254,877.067104 L400,875 L400,275 C400,205.964406 344.035594,150 275,150 Z',
  'M275,200 C316.421356,200 350,233.578644 350,275 L350,875 C350,916.421356 316.421356,950 275,950 C233.578644,950 200,916.421356 200,875 L200,275 C200,233.578644 233.578644,200 275,200 Z'
]

export const getPath = (x, y) => translatePath(path, defaultX, defaultY, x, y)

const P = () => (
  <symbol id="p" viewBox={`${defaultX} ${defaultY} ${width} ${height}`}>
    <path d={path.join(' ')} />
  </symbol>
)

export default P
